export interface JobHistory {
  vpJobId: string;
  jobClass: string;
  craft: string;
  payRate: number;
  startDate: Date;
  rofDate: Date;
  hrsWorked: number;
}
